import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('All');
  const filters = ['All', 'Branding', 'Web Design', 'UI/UX', 'Mobile'];
  const projects = [{
    title: 'Horizon Finance',
    category: 'Web Design',
    image: 'https://images.unsplash.com/photo-1541462608143-67571c6738dd?q=80&w=2070&auto=format&fit=crop',
    year: '2023'
  }, {
    title: 'Bloom Beauty',
    category: 'Branding',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?q=80&w=2000&auto=format&fit=crop',
    year: '2023'
  }, {
    title: 'Pulse App',
    category: 'Mobile',
    image: 'https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?q=80&w=2000&auto=format&fit=crop',
    year: '2022'
  }, {
    title: 'Nova Interiors',
    category: 'UI/UX',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=2158&auto=format&fit=crop',
    year: '2022'
  }, {
    title: 'Vertex Tech',
    category: 'Branding',
    image: 'https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?q=80&w=2001&auto=format&fit=crop',
    year: '2021'
  }, {
    title: 'Urban Eats',
    category: 'Mobile',
    image: 'https://images.unsplash.com/photo-1482442120256-9c4a5ab72d4c?q=80&w=1935&auto=format&fit=crop',
    year: '2021'
  }];
  const filteredProjects = activeFilter === 'All' ? projects : projects.filter(project => project.category === activeFilter);
  return <section id="work" className="bg-white border-b-2 border-black" data-id="element-169">
      <div className="container mx-auto px-0" data-id="element-170">
        {/* Header & Filter */}
        <div className="p-8 lg:p-12 border-b-2 border-black flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8" data-id="element-171">
          <div data-id="element-172">
            <h2 className="text-5xl md:text-7xl font-heading font-black text-black uppercase leading-none mb-4" data-id="element-173">
              Selected
              <br data-id="element-174" />
              Works
            </h2>
          </div>

          <div className="flex flex-wrap gap-2" data-id="element-175">
            {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-6 py-2 border-2 border-black text-sm font-bold uppercase tracking-wider transition-all ${activeFilter === filter ? 'bg-black text-white shadow-[4px_4px_0px_0px_#FF3300]' : 'bg-white text-black hover:bg-gray-100'}`} data-id="element-176">
                {filter}
              </button>)}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3" data-id="element-177">
          <AnimatePresence data-id="element-178">
            {filteredProjects.map((project, index) => <motion.div layout initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.3
          }} key={project.title} className={`group relative aspect-square border-b-2 border-black ${(index + 1) % 3 !== 0 ? 'lg:border-r-2' : ''} ${(index + 1) % 2 !== 0 ? 'md:border-r-2 lg:border-r-0' : ''}`} data-id="element-179">
                <div className="absolute inset-0 bg-black group-hover:bg-swiss-red transition-colors duration-300" data-id="element-180">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover opacity-60 group-hover:opacity-40 transition-opacity duration-300 grayscale group-hover:grayscale-0" data-id="element-181" />
                </div>

                <div className="absolute inset-0 p-8 flex flex-col justify-between" data-id="element-182">
                  <div className="flex justify-between items-start text-white" data-id="element-183">
                    <span className="font-bold uppercase tracking-widest text-sm border border-white px-2 py-1" data-id="element-184">
                      {project.category}
                    </span>
                    <span className="font-bold" data-id="element-185">{project.year}</span>
                  </div>

                  <div data-id="element-186">
                    <h3 className="text-3xl font-black text-white uppercase mb-2 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-187">
                      {project.title}
                    </h3>
                    <div className="w-12 h-12 bg-white text-black flex items-center justify-center rounded-none translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 delay-75" data-id="element-188">
                      <ArrowUpRight size={24} data-id="element-189" />
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}